import"./CustomIcon.css.ts.vanilla.css";var s={icon:"CustomIcon_styles_icon__ehllw00"};export{s as styles};
//# sourceMappingURL=CustomIcon.css.vanilla.js.map
